import React from 'react';
import CardGrid from './CardGrid'; // Importa el componente CardGrid

const ExperienceSection = ({ experiences}) => {
  return (
    <div className="experience-section">
      <CardGrid cards={experiences} /> {/* Usa CardGrid para mostrar las experiencias */}
    </div>
  );
};

export default ExperienceSection;